import { createContext } from 'react';

export const initialState = {
  offerType: 'Prepay SIM',
  handsetType: 'Prepay Phone & SIM',
  offers: [],
  prepaySIM: true,
};

export const prepayOfferReducer = (state, action) => {
  switch (action.type) {
    case 'offerType': {
      return {
        ...state,
        offerType: action.payload,
      };
    }
    case 'handsetType': {
      return {
        ...state,
        handsetType: action.payload,
      };
    }
    case 'offers': {
      return {
        ...state,
        offers: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
export const PrepayOfferContext = createContext();
